/**
 * @file: versions.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  AllDetailVersionKeys,
  TaskDetail,
  TaskDetailVersions,
} from '@euler/model/task-detail';

export const getDetailVersions = (detail: TaskDetail): TaskDetailVersions => {
  return {
    detail: detail.version,
    basicInfo: detail.basicInfo?.version ?? 0,
    preInspection: detail.preInspection?.version ?? 0,
    inspection: detail.inspection?.version ?? 0,
    obdInspection: detail.obdInspection?.version ?? 0,
    construction: detail.construction?.version ?? 0,
    deliveryCheck: detail.deliveryCheck?.version ?? 0,
    samplingCheck: detail.samplingCheck?.version ?? 0,
    maintenancePlan: detail.maintenancePlan?.version ?? 0,
    productManifest: detail.productManifest?.version ?? 0,
    quotation: detail.quotation?.version ?? 0,
  };
};

export const detailVersionsMatch = (
  a: TaskDetailVersions,
  b: TaskDetailVersions,
) => {
  for (const key of AllDetailVersionKeys) {
    if (a[key] !== b[key]) return false;
  }
  return true;
};
